import { IntlShape } from "react-intl"
import defaultStrings from "../intl/en.json"

export type TranslationKey = keyof typeof defaultStrings

export const isTranslationKey = (key: string): key is TranslationKey =>
  Object.keys(defaultStrings).includes(key as TranslationKey)

const consoleError = (message: string): void => {
  const { NODE_ENV } = process.env
  if (NODE_ENV === "development") {
    console.error(message)
  }
}

// Returns the en.json value
export const getDefaultMessage = (key: TranslationKey): string => {
  const defaultMessage = defaultStrings[key]
  if (defaultMessage === undefined) {
    consoleError(
      `No key "${key}" in en.json. Cannot provide a default message.`
    )
  }
  return defaultMessage || ""
}

export const translateMessageId = (
  id: TranslationKey,
  intl: IntlShape
): string => {
  if (!id) {
    consoleError(`No id provided for translation.`)
    return ""
  }
  if (!intl || !intl.formatMessage) {
    consoleError(`Invalid/no intl provided for translation id ${id}`)
    return ""
  }
  const translation = intl.formatMessage({
    id,
    defaultMessage: getDefaultMessage(id),
  })
  if (translation === id) {
    consoleError(
      `Intl ID string "${id}" has no match. Default message of "" returned.`
    )
    return ""
  }
  return translation
}